<template>
  <div :class="`p_onePass${hide ? ' p_driving_hide':''}`">
    <el-form
      v-show="!hide"
      v-loading="loading"
      :model="form"
      ref="myForm"
      :rules="rules"
      hide-required-asterisk
    >
      <!-- 身份證明文件類別 -->
      <el-form-item
        :label="$t('message.idType')"
        prop="identType"
      >
        <el-select
          v-model="form.identType"
          value-key="code"
          filterable disabled
        >
          <el-option
            v-for="item in idType"
            :key="item.code"
            :label="$t(item.label)"
            :value="item.code"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 澳門居民身份證編號 -->
      <el-form-item
        :label="$t('message.idNo')"
        prop="identityNo"
      >
        <el-input v-model="form.identityNo" disabled></el-input>
      </el-form-item>
      <!-- 澳門流動電話 -->
      <el-form-item :label="$t('message.Verification.mobile')" prop="mobile">
        <el-input
          v-model.number="form.mobile"
          :placeholder="$t('message.Verification.mobile_placeholder')"
          disabled
        ></el-input>
      </el-form-item>
      <!-- 錯誤信息 -->
      <el-form-item v-if="vssData && vssData.spCode != '00'" label="">
        <div class="ps_msgBox">
          <div class="ps_msg_failed">
            <div class="failed_text">
              <i class="el-icon-warning"></i>
              <span>{{ $t("message.DataRegistration.International.canNotApply") }}</span>
            </div>
            <div class="failed_reason">
              {{ $t("message.reason")}}
              {{(vssData && vssData[`spResult${$i18n.locale == "ZH_TW" || $i18n.locale == "ZH_CN"? "Cn" : "Pt" }`]) || "" }}
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item class="submit_btn">
        <GradientBtn v-if="vssData && vssData.spCode != '00' && !$store.state.isApp" @click="logout">{{
          $t("message.logout_account")
        }}</GradientBtn>
        <GradientBtn v-if="vssData && vssData.spCode == '00' && $store.state.isApp" @click="submit" :loading="loading">{{
          $t("message.account_submit")
        }}</GradientBtn>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import i18n from "../../../../public/lang/index";
import GradientBtn from "../../../components/GradientBtn";
import LoginAPI from "../../../api/LoginAPI";
import DrivIntApplicationAPI from "../../../api/DrivIntApplicationAPI";
import safpBridgeObj from "../../../plugins/govmo-js-sdk";
import { basePath } from "../../../api/axios";
export default {
  components: { GradientBtn },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      // 驗證澳門手機
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("message.formRuleMessage.macauMobile")));
      } else {
        callback();
      }
    };
    return {
      // form: {},
      basePath: basePath,
      loading: false,
      hide: true,
      rules: {
        identityNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
        mobile: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
        ],
      },
      idType: [
        { code: "BM", label: "message.idType_macau" },
        {
          code: "OTHER",
          label: "message.idType_other",
        },
      ],
      vssData: {},
    };
  },
  computed: {
    form: {
      get() {
        return this.$store.state.verifyForm;
      },
      set(value) {
        this.$store.commit("changeVerifyForm", value);
      },
    },
    serviceType() {
      return this.$route.meta.serviceType;
    },
  },
  methods: {
    submit() {
      this.$refs.myForm.validate((valid) => {
        if (valid) {
          localStorage.setItem("verifyForm", JSON.stringify(this.form));
          this.internationCheck();
        }
      });
    },
    // 驗證國際駕照服務准入條件
    internationCheck() {
      const serviceType = this.serviceType;
      const verifyForm = this.form;
      let identType = verifyForm.identType;
      let identNo = verifyForm.identityNo;
      // let licenseNo = process.env.VUE_APP_ENV === 'development' ? '11234': null;
      let licenseNo = null;
      const spNo = this.form.spNo;
      this.loading = true;
      DrivIntApplicationAPI.check(serviceType, identType, identNo, licenseNo, spNo)
        .then((res) => {
          this.loading = false;
          this.hide = false;
          this.vssData = res.application;
          const errSpCode = ['D01','D02','D11','D21','D23','D41','D99'];
          if (res && res.application && errSpCode.includes(res.application.spCode)) {
            this.$message({
              type: "error",
              message: res.application[`spResult${this.$t('message.lans')}`],
            });
          } else {
            localStorage.setItem("form", "");
            this.$store.commit("changeDocumentType", []);
            localStorage.setItem("drivApplication", JSON.stringify(res));
            this.$store.commit("changeDrivApplication", res);
            this.$router.replace("/international");
          }
        })
        .catch(err => {
          this.loading = false;
          this.hide = false;
          this.$error(err)
        })
    },
    // 一戶通登入
    accountLogin(code, token) {
      const serviceType = this.serviceType;
      this.loading = true;
      LoginAPI.account(code, token, serviceType)
        .then((res) => {
          this.loading = false
          localStorage.setItem("accountData", JSON.stringify(res.data));
          localStorage.setItem("accountCode", code);
          localStorage.setItem("authentication", res.headers.authentication);
          this.$set(this.form, "identityNo", res.data.identityNo);
          this.$set(this.form, "identNo", res.data.identityNo);
          // 非澳門電話
          // if(res.data.mobile.indexOf('+') != -1){
          //   return;
          // }else{
            this.$set(this.form, "mobile", res.data.mobile);
          // }
          this.submit();
        })
        .catch((err) => {
          this.loading = false
          if (err.message.indexOf("401") != -1) {
            if (this.$store.state.isApp) {
              safpBridgeObj.getToken({
                success(res) {
                  console.log(res);
                  if (res && res.authToken) {
                    this.accountLogin(null, res.authToken, serviceType);
                  }
                },
                fail(res) {
                  console.log(res);
                  this.$message({
                    type: "error",
                    message: this.$t("message.accountLoginFailed"),
                  });
                },
              });
            } else {
              this.$router.replace("/personal");
            }
          } else {
            this.$error(err);
            this.$router.replace("/personal");
          }
        })
    },
    // 登出
    logout() {
      const lang = this.$t('message.lang_account');
      window.location.replace(`${process.env.VUE_APP_ACCOUNT_PATH}/${lang}/logout/`);
    }
  },
  created() {
    const code = this.$route.query.code || null;
    const token =
      sessionStorage.getItem("accountToken") || this.$route.query.token || null;
    const serviceType = this.serviceType;
    const accountCode = localStorage.getItem("accountCode") || null;
    const accountData = JSON.parse(localStorage.getItem("accountData")) || null;
    if ((token || (code && accountCode != code)) && serviceType) {
      this.accountLogin(code, token);
    } else {
      if (!accountData) {
        this.$message({
          type: "error",
          message: this.$t("message.accountLoginFailed"),
        });
      }
      this.$router.push("/personal");
    }
  },
};
</script>

<style lang="scss" scoped>
.p_driving_hide{
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  background: #fff;
}
.captcha_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.getVerify_btn {
  margin-left: 16px;
  min-width: 150px;
}
</style>